import { render, staticRenderFns } from "./AssignedTask.vue?vue&type=template&id=3ddd359c"
import script from "./AssignedTask.vue?vue&type=script&lang=js"
export * from "./AssignedTask.vue?vue&type=script&lang=js"
import style0 from "./AssignedTask.vue?vue&type=style&index=0&id=3ddd359c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports